<template>
  <div class="multiple_graphic_echart">
    <div class="graph">
      <v-chart ref="vgraph" :autoresize="true" :manual-update="true" />
      <div class="graph-buttons" v-if="wb">
        <button
          v-for="item in btns"
          v-bind:class="{ active: item.active }"
          :key="item.idx"
          @click="changeScale(item)"
        >
          {{ item.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
import ECharts from "vue-echarts";
import axios from "axios";

import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from "echarts/components";
import { echartformat } from "../../../functions/general-functions";
Vue.use(VueCompositionAPI);
echarts.use([
  LineChart,
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  CanvasRenderer,
]);

export default {
  components: { "v-chart": ECharts },
  props: {
    withButtons: Boolean,
    st: String,
    de: Number,
    sc: Number,
    tk: Number,
    quotes: Array,
    color: Array,
  },
  created: function () {
    this.wb = this.withButtons ? this.withButtons : false;
    this.style = this.st ? this.st : "currency";
    this.decimals = this.de ? this.de : 2;
    this.params = {
      scale: this.sc ? this.sc : undefined,
      take: this.tk ? this.tk : undefined,
    };
    const _self = this;
    this.graphData = {
      color: this.color
        ? this.color
        : ["#39b54a", "#f7931e", "#0071bc", "#ed1c24", "#93278f", "#ed1e79"],
      title: {
        show: false,
      },
      textStyle: {
        fontFamily: '"Montserrat", sans-serif',
      },
      legend: {
        show: true,
        bottom: "10",
      },
      xAxis: {
        type: "category",
        axisTick: {
          alignWithLabel: true,
        },
        splitLine: {
          show: true,
          interval: "auto",
        },
        interval: 5,
      },
      yAxis: [
        {
          show: true,
          scale: true,
          axisLabel: {
            formatter: function (vv) {
              var val = echartformat(vv, _self.style, _self.decimals);
              return val;
            },
          },
        },
        {
          show: true,
          scale: true,
          axisLabel: {
            formatter: function (vv) {
              var val = echartformat(vv, _self.style, _self.decimals);
              return val;
            },
          },
          position: "right",
        },
      ],
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          var resTooltip = params[0].name + "<br/>";
          params.forEach(function (el) {
            const valRef = el.value[el.seriesIndex + 1];
            if (valRef) {
              resTooltip =
                resTooltip +
                el.marker +
                el.dimensionNames[el.seriesIndex + 1] +
                " " +
                echartformat(
                  el.value[el.seriesIndex + 1],
                  _self.style,
                  _self.decimals
                ) +
                "<br/>";
            }
          });
          return resTooltip;
        },
      },
    };
  },
  mounted: function () {
    this.initGraph();
    this.updateGraphicData(this.wb);
  },
  watch: {
    quotes: function (newVal, oldVal) {
      this.initGraph();
      this.updateGraphicData(this.wb);
    },
  },
  methods: {
    initGraph: function () {
      const _self = this;
      this.params.names = this.quotes.map(function (v) {
        return v.id + "|" + v.name;
      });

      let gGrid = {
        left: "80",
        right: "20",
        bottom: "60",
        top: "20",
      };
      const coffee = this.quotes.filter((el) => {
        return el.id === 30;
      });

      if (coffee.length) {
        gGrid = {
          left: "60",
          right: "90",
          bottom: "100",
          top: "20",
        };
      }
      this.graphData.grid = gGrid;
      this.graphData.series = this.quotes.map((q, idx) => {
        return {
          type: "line",
          showSymbol: true,
          yAxisIndex: q.id === 30 ? 1 : 0,
          connectNulls: true,
          label: {
            show: false,
          },
          encode: {
            seriesName: [idx + 1],
            x: 0,
            y: idx + 1,
          },
        };
      });
    },
    updateGraphicData: function (firstTime) {
      var _self = this;
      axios
        .get(this.url, {
          params: this.params,
        })
        .then(function (d) {
          var data = d.data;
          if (_self.wb && firstTime) {
            _self.btns = data.buttonsData;
          }
          _self.graphData.dataset = {
            source: data.graphData,
          };
          setTimeout(() => {
            _self.$refs.vgraph.setOption(_self.graphData, true, true);
          }, 500);
        });
    },
    changeScale: function (btn) {
      this.btns = this.btns.map((q) => {
        q.active = false;
        return q;
      });
      btn.active = true;
      this.params.scale = btn.scale;
      this.updateGraphicData(false);
    },
  },
  computed: {
    url: function () {
      return "/api/quote/multiple";
    },
  },
  data: function () {
    return {
      wb: false,
      btns: [],
    };
  },
};
</script>